import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Preset di reveal richiamabili dai blocchi via data-anim.
const PRESETS = {
	fade: { opacity: 0 },
	'fade-up': { opacity: 0, y: 40 },
	'fade-left': { opacity: 0, x: -40 },
	'fade-right': { opacity: 0, x: 40 },
};

/**
 * Attiva le animazioni di reveal su tutti gli elementi [data-anim] dentro root.
 * Esempio markup: <div data-anim="fade-up" data-anim-delay="0.1">
 */
export function initAnimations( root = document ) {
	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		return;
	}

	root.querySelectorAll( '[data-anim]' ).forEach( ( el ) => {
		const preset = PRESETS[ el.dataset.anim ] || PRESETS[ 'fade-up' ];
		const delay = parseFloat( el.dataset.animDelay || '0' );

		gsap.from( el, {
			...preset,
			duration: 0.9,
			delay,
			ease: 'power3.out',
			scrollTrigger: { trigger: el, start: 'top 85%', once: true },
		} );
	} );
}

export { gsap, ScrollTrigger };
